import { HttpErrorResponse } from '@angular/common/http';

/** Status, bei denen der Server nur kurz weg ist (Netz, Gateway, Deployment) und ein erneuter Versuch helfen kann. */
const TRANSIENT_STATUSES: ReadonlySet<number> = new Set([0, 502, 503, 504]);

/**
 * Das eigene Backend antwortet bei Fremdsystem-Problemen bewusst mit 502 und einem JSON-Body
 * `{ error, code? }` (ApiExceptionHandler: JIRA_UNREACHABLE, REDMINE_UNREACHABLE, GitHub upstream error).
 * Dann läuft unser Server, und Wiederholen fragt nur das Fremdsystem erneut an. Ein Gateway
 * (nginx, Ingress) liefert dagegen HTML oder keinen Body.
 */
function isOwnBackendErrorBody(body: unknown): boolean {
  if (typeof body !== 'object' || body === null) {
    return false;
  }
  const { code, error } = body as { code?: unknown; error?: unknown };
  return typeof code === 'string' || typeof error === 'string';
}

export function isTransientError(error: unknown): boolean {
  if (!(error instanceof HttpErrorResponse) || !TRANSIENT_STATUSES.has(error.status)) {
    return false;
  }
  return error.status === 0 || !isOwnBackendErrorBody(error.error);
}
